import { Injectable, signal } from '@angular/core';
import { TreeNode } from '@shared/components/tree-select/Domain/treeNode.model';
import { SelectionMode } from '@shared/components/tree-select/Domain/selectionMode.enum';
import { TreeSelectService } from '@shared/components/tree-select/Application/treeSelect.service';

@Injectable({ providedIn: 'root' })
export class TreeSelectFacade {
  readonly nodes = signal<TreeNode[]>([]);
  readonly selectedNodes = signal<TreeNode[]>([]);
  readonly searchQuery = signal<string>('');
  readonly isOpen = signal<boolean>(false);

  constructor(private readonly treeSelectService: TreeSelectService) {}

  initialize(nodes: TreeNode[], selectedKeys: string[]) {
    this.nodes.set(nodes);
    this.selectedNodes.set(this.treeSelectService.findNodesByKeys(nodes, selectedKeys));
    this.treeSelectService.expandParentsForSelected(nodes, selectedKeys);
  }

  toggleDropdown() {
    this.isOpen.update((open) => !open);
  }

  selectNode(node: TreeNode, mode: SelectionMode) {
    const current = this.selectedNodes();
    const exists = current.some((n) => n.key === node.key);

    if (mode === SelectionMode.SINGLE) {
      this.selectedNodes.set([node]);
      this.isOpen.set(false);
    } else {
      this.selectedNodes.set(
        exists ? current.filter((n) => n.key !== node.key) : [...current, node],
      );
    }
  }

  clearSelection() {
    this.selectedNodes.set([]);
  }

  updateSearch(query: any) {
    this.searchQuery.set(query);
  }

  getFilteredNodes(): TreeNode[] {
    return this.treeSelectService.filterNodes(this.nodes(), this.searchQuery());
  }
}
